import BaseIcon from "./BaseIcon.jsx";
import BaseButtons from "./BaseButtons.jsx";
import BaseButton from "./BaseButton.jsx";

export default function CardBox({
  children,
  title,
  icon,
  footer,
  hasTable = false,
  isForm = false,
  className = "",
  onSubmit,
}) {
  const Tag = isForm ? "form" : "div";

  return (
    <Tag
      className={[
        "rounded-2xl border border-gray-200 dark:border-slate-700",
        "bg-white dark:bg-slate-900/70 flex flex-col",
        className,
      ].join(" ")}
      onSubmit={isForm ? onSubmit : undefined}
    >
      {title && (
        <div className="flex items-center gap-2 px-5 py-4 border-b border-gray-100 dark:border-slate-700">
          {icon && <BaseIcon path={icon} className="text-gray-400" />}
          <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-200">{title}</h3>
        </div>
      )}

      <div className={hasTable ? "" : "flex-1 p-5"}>
        {children}
      </div>

      {footer && (
        <div className="border-t border-gray-100 dark:border-slate-700 px-5 py-3">
          {footer}
        </div>
      )}
    </Tag>
  );
}
